module.exports = __webpack_public_path__ + "img/jbd1.7311db5a.png";